import PropTypes from "prop-types";
import React from "react";
import {
  StyleSheet,
  View,
  TouchableOpacity,
  Platform,
  Animated,
  Easing,
} from "react-native";
import ENV from "app/utils/ENV";
import Text from "app/components/Text";
import apiActions from "app/utils/apiActions";
import textHelpers from "app/utils/textHelpers";
import colorHelpers from "app/utils/colorHelpers";
import valueHelpers from "app/utils/valueHelpers";
import timeHelpers from "app/utils/timeHelpers";
import frequencyHelpers from "app/utils/frequencyHelpers";
import valueActions from "app/utils/valueActions";
import * as RootNavigation from "app/utils/RootNavigation.js";
import Svg, {
  Path,
  Ellipse,
  Circle,
  Rect,
  Text as SvgText,
} from "react-native-svg";
import { styleSheet, colors, sizes, screenRatio } from "app/utils/styleSheet";
import storageActions from "app/utils/storageActions";

import Icon from "app/components/Icon";
import { Ionicons, FontAwesome, Feather, Entypo } from "@expo/vector-icons";

let CAP_AT_CYCLE = false;
// if false, incomplete progress notches will flex to fit overflow
// CAP_AT_CYCLE = true;

let OUTER_RING_OVERFLOW = true;
OUTER_RING_OVERFLOW = false;
// if true, only up to cycle(7) slots will be shown
// although cycle(7)+ completed notches will still condense

let INVERT_NOTCH_COLORS = false; // parent color for notch border, child for notch fill
INVERT_NOTCH_COLORS = true; // opposite

let SHOW_CYCLE_OUTLINE = false;

import store from "app/redux/store";
import { StyleContext } from "app/contexts/Style";

export default class ProgressRing extends React.Component {
  static contextType = StyleContext;
  static propTypes = {
    value: PropTypes.object.isRequired,
    size: PropTypes.number.isRequired,
    // color: PropTypes.string,
    selected: PropTypes.bool,
    progressBar: PropTypes.bool,
  };

  static defaultProps = {
    coloredNotches: true,
  };

  render() {
    // return null
    // if(!ENV.WEB) return null
    let { value, size, color, selected } = this.props;
    return this.renderProgressRing(selected, color);
  }

  componentDidMount() {
    this.subscribe();
  }

  componentWillUnmount() {
    this.unsubscribeRedux && this.unsubscribeRedux();
  }

  subscribe = async () => {
    this.unsubscribeRedux = store.subscribe(() => {
      let { values } = store.getState();
      let { app, value } = this.props;
      let shouldUpdate = false;
      if (values.length != this.state.valuesCount) shouldUpdate = true;
      if (
        !textHelpers.compareObjects(
          values.find((v) => v.id == value.id)?.notches,
          value.notches
        )
      )
        shouldUpdate = true;
      if (!shouldUpdate) return;
      this.setState({ valuesCount: values.length });
      console.log("updating progress ring of ", value.text);
      this.setState({ ...this.initialState() });

      // if (textHelpers.compareObjects(app.updateValueIds, this.state.updatedValueIds)) return;
      // this.setState({updatedValueIds: app.updateValueIds})
      // if(!app.updatedValueIds.includes(value.id)) return
      // // let updatedValue = values.find((v) => v.id == value.id)
      // console.log('updating progress ring of ', value.text)
      // this.setState({ ...this.initialState() });
    });
  };

  constructor(props, context) {
    super(props, context);

    let { sizeRatio, appliedScreenRatio, gutter } = this.getSizes();

    let staticState = {
      completed: !!valueHelpers.getCompletedAt(props.value),
      completionAnimRunning: false,
      rotAnim: new Animated.Value(0),
      scaleAnim: new Animated.Value(1),
      progressAnimRunning: false,
      progressAnim: new Animated.Value(1),
      centralValue:
        RootNavigation.navigationRef?.current?.getCurrentRoute()?.params?.id ==
        props.value.id,
      Elem: props.progressBar ? Path : Circle,
    };

    let dynamicState = this.initialState(staticState, context);

    this.state = {
      ...staticState,
      ...dynamicState,
      updatedValueIds: [],
    };
  }

  getSizes = () => {
    let { size, ignoreScreenRatio } = this.props;
    let appliedScreenRatio = ignoreScreenRatio ? 1 : screenRatio;
    let sizeRatio = size * appliedScreenRatio;
    let gutter = size * 0.5 * appliedScreenRatio;
    return {
      appliedScreenRatio,
      sizeRatio,
      gutter,
    };
  };

  initialState = (state = null, context = null) => {
    context = context || this.context;
    let { value, color, size, ignoreScreenRatio, progressBar, coloredNotches } =
      this.props;
    let { centralValue, progressAnimRunning } = state || this.state;
    let { sizeRatio, appliedScreenRatio, gutter } = this.getSizes();

    let completedAt = valueHelpers.getCompletedAt(value);
    let completedToday = timeHelpers.wasToday(completedAt);

    let doneToday = valueHelpers.wasProgressedToday(value);

    // let { progressions, incompleteChildren } = valueHelpers.getNotches(value);
    let progressions = value.notches?.closed_notches || [];
    let incompleteChildren = value.notches?.open_notches || [];

    let cycle = valueHelpers.getCycle(value);
    let steps = this.getSteps(
      value,
      value.cycle,
      progressions,
      incompleteChildren
    );

    // console.log("initial state.....", progressions, incompleteChildren, steps);

    // SIZING VARS
    let strokeWidth = Math.max(1, sizeRatio * 0.04);
    let progressStrokeWidth = strokeWidth;

    let outterR = (size / 2) * appliedScreenRatio;
    let R = Math.max(0, outterR - 4);
    let C = 2 * Math.PI * R;
    if (progressBar) {
      C = sizeRatio;
    }

    let dotSize = strokeWidth;
    let dotGap = dotSize * 1.5;
    let dotGapArc = this.distanceAsArc(dotGap, R, C);

    let slot = C / steps;
    let slotGap = dotGapArc * 2;
    if (steps > 14) slotGap = dotGapArc * 1;
    let slotFill = slot - slotGap;
    let rootOffset = 0;
    let offset = -slotGap / 2;

    // REVISION DOTS
    let revisionDotsSpan = 0;
    let revisionWeights = [];
    let rotation = 0;

    if (valueHelpers.isReference(value)) {
      revisionWeights = ["#"];
    } else if (valueHelpers.isInfinite(value)) {
      revisionWeights = ["∞"];
    } else {
      // let revisions = valueHelpers.getPastRevisions(value);
      let revisions = [...(value.revision_ids || [])].filter(
        (id) => id < value.id
      );
      while (revisions.length >= 10) {
        revisions.splice(0, 10);
        revisionWeights.push(10);
      }
      while (revisions.length >= 5) {
        revisions.splice(0, 5);
        revisionWeights.push(5);
      }
      while (!!revisions.length) {
        revisions.splice(0, 1);
        revisionWeights.push(1);
      }
      if (CAP_AT_CYCLE && steps == cycle) {
        let uncappedSteps = this.getSteps(
          value,
          0,
          progressions,
          incompleteChildren
        );
        if (uncappedSteps > cycle) {
          revisionWeights.push("+");
        }
      }
    }

    if (value.id == 182 || value.id == 734.1) {
      revisionWeights.push("+");
    }

    let revisionDashArray = new Array(revisionWeights.length)
      .fill([0, dotGapArc])
      .flat();
    let revisionWeightsLength = 0;
    let revisionDotsArc;
    let ringOffset;
    if (revisionDashArray.length) {
      revisionWeightsLength = revisionWeights.length - 1;
      if (["#", "∞"].includes(revisionWeights[0])) revisionWeightsLength = 1;
      revisionDotsArc = dotGapArc * revisionWeightsLength;
      rotation = -(revisionDotsArc / 2);
      if (progressBar) rotation = 0;
      // rotation = 0

      revisionDotsSpan = dotGapArc * revisionWeightsLength;

      rootOffset = -1;
      ringOffset = dotGapArc * revisionWeightsLength;

      // update other ring values
      offset = -ringOffset;
      offset -= dotGapArc;

      slot = (C - revisionDotsSpan) / steps;
      // slotFill = slot * 0.8
      // slotGap = slot * 0.2
      slotFill = slot - slotGap;

      revisionDashArray.pop(); // replace last dotSize gap
      revisionDashArray.push(C); // clear the end
    }

    // NOTCHES
    let dashArray = new Array(steps).fill([slotFill, slotGap]).flat();
    dashArray.pop();
    dashArray.push(C);
    let progressLinecap = "round";
    let dashCount = progressions.length;
    if (progressAnimRunning) dashCount -= doneToday;
    let progressStartDash = [];
    let progressEndDash = [slotFill / 2, C];
    let progressSquareOffset = offset;
    let progressEndOffset = 0;
    // dashCount = steps
    let progressDash;
    let progressDashArray = new Array(dashCount)
      .fill([slotFill, slotGap])
      .flat();
    if (!!completedAt) {
      if (
        this.props.coloredNotches ||
        (this.props.noteValue && !completedToday)
      ) {
        // progressStrokeWidth /= 3
        // if(doneToday) progressStrokeWidth *= 1.5
      }
      progressDashArray = [C - revisionDotsSpan - dotGapArc * 2];
      if (!revisionWeights.length) {
        progressDashArray = [C];
        offset = 0;
        progressSquareOffset = 0;
        if (!progressBar) {
          progressLinecap = "square";
        }
      }

      if (!!value.parent) {
        let completionStaleness = frequencyHelpers.getStaleness(
          value,
          value.completed_at,
          value.parent?.progress_at[
            value.parent?.progress_at.findIndex(
              (p) => p == value.completed_at
            ) + 1
          ]
        );
        // console.log("completion staleness", completionStaleness, value);
        progressStrokeWidth =
          strokeWidth - (strokeWidth / 2) * completionStaleness;
      }
    } else if (!!progressDashArray.length) {
      progressEndOffset =
        -(progressDashArray.reduce((a, b) => a + b) + slotFill / 2) + offset;
      progressEndOffset += slotFill + slotGap;

      // progressDashArray[0] = slotFill/2
      // progressSquareOffset -= (slotFill/2)
      progressStartDash = [slotFill / 2, C];
      progressDashArray.pop();
      progressDashArray.push(C); // clear the end
    }

    let todayDashArray = [];
    let todayOffset = 0;
    let todayLinecap = "round";
    if (!!doneToday && !completedAt) {
      if (!!completedAt && !this.props.coloredNotches) {
        todayDashArray = [C - revisionDotsSpan - dotGapArc * 2];
        if (!revisionWeights.length) {
          todayDashArray = [C];
          todayLinecap = "square";
          offset = 0;
        }
      } else {
        progressions.map((p) => {
          if (!!p && timeHelpers.wasToday(p.timestamp)) {
            todayDashArray.push(slotFill, slotGap);
          } else {
            todayOffset -= slotFill + slotGap;
          }
        });
      }
      todayDashArray.pop();
      todayDashArray.push(C); // clear the end
      // console.log(progressions, todayDashArray, todayOffset)
    }

    let archiveOffset = 0;
    let childrenOffset = 0;
    let childrenLinecap = "round";
    progressions.map((p) => {
      archiveOffset -= slotFill + slotGap;
      childrenOffset -= slotFill + slotGap;
    });

    let childrenDashArray = [];
    let childrenProgress = [];
    let overflowDashArray = [];
    let overflowProgress = [];
    if (!this.props.noteValue) {
      if (!!incompleteChildren?.length) {
        // if (
        //   incompleteChildren.length == 1 &&
        //   cycle == 1 &&
        //   !revisionWeights?.length
        // ) {
        //   childrenDashArray = [C];
        //   offset = 0;
        //   childrenLinecap = "square";
        //   childrenOffset = 0;
        // } else {
        incompleteChildren.forEach((child, i) => {
          let overflowing = false;
          if (CAP_AT_CYCLE) {
            if (cycle !== 0) {
              if (i >= cycle - dashCount) overflowing = true;
              if (i + progressions.length + 1 > cycle) overflowing = true;
              // ^ are those the same?
              if (overflowing && !OUTER_RING_OVERFLOW) {
                // if (centralValue)
                //   console.log("RETURNING due to overflow", i, child);
                // return;
              }
            }
          }

          // if (value.id == 700) console.log("notttch", i, child);

          // if(overflowing && OUTER_RING_OVERFLOW){
          //   overflowDashArray.push(slotFill, slotGap)
          // }
          // else {
          childrenDashArray.push(slotFill, slotGap);
          // }

          if (typeof child == "object") {
            let percent = child.percent;
            childrenProgress.push({
              offset: childrenOffset - i * (slotFill + slotGap),
              dashArray: [slotFill * percent, C],
              color: valueHelpers.getColor(child, context.colorScheme),
              rawColor: child.color,
              percent: percent,
              updated_at: child.timestamp,
              created_at: child.timestamp,
              timestamp: child.timestamp,
              iterations: child.iterations,
              // isInfinite: childIsInfinite,
              isInfinite: false,
              // freshness,
              item: { id: child.id },
              cycle: 7,
              steps: 7,
            });
          } else if (false) {
            // let {
            //   progressions: childProgressions,
            //   incompleteChildren: incompleteGrandChildren,
            // } = valueHelpers.getNotches(child);
            // console.log(
            //   "child",
            //   child,
            //   incompleteGrandChildren,
            //   childProgressions
            // );
            // let childCycle = valueHelpers.getCycle(child);
            // let childSteps = this.getSteps(
            //   child,
            //   childCycle,
            //   childProgressions,
            //   incompleteGrandChildren
            // );
            // if (!ENV.STACK_PROGRESS && !!childCycle) {
            //   if (childSteps > childCycle) {
            //     // childSteps = childProgressions.length;
            //     childSteps = childCycle;
            //     // ?
            //   }
            // }
            // let childProgress = !!childSteps
            //   ? childProgressions.length / childSteps
            //   : 0;
            // let freshness = 0;
            // let childIsInfinite = valueHelpers.isInfinite(child);
            // // no infinite child notches
            // if (childIsInfinite) return;
            // if (childIsInfinite || !!child.frequency) {
            //   freshness = frequencyHelpers.getFreshness(child);
            //   if (childIsInfinite) {
            //     childProgress = freshness;
            //   }
            // }
            // // if (centralValue) console.log("childprogrss", i, child, childProgress);
            // if (!!childProgress || childProgress === 0) {
            //   childProgress = Math.min(childProgress, 1);
            //   let childColor = coloredNotches
            //     ? valueHelpers.getColor(child, this.context.colorScheme)
            //     : color;
            //   // if (!!modifyingColorBy) {
            //   //   modifyingColorBy.forEach((mod) => {
            //   //     childColor = colorHelpers.modifyHex(childColor, mod);
            //   //   });
            //   // }
            //   let progressObj = {
            //     offset: childrenOffset - i * (slotFill + slotGap),
            //     dashArray: [slotFill * childProgress, C],
            //     color: childColor,
            //     percent: childProgress,
            //     updated_at: child.updated_at,
            //     created_at: child.created_at,
            //     iterations: child.iterations,
            //     isInfinite: childIsInfinite,
            //     freshness,
            //     item: child,
            //     cycle: childCycle,
            //     steps: childSteps,
            //   };
            //   // if (centralValue)
            //   //   console.log(
            //   //     "childprogrss",
            //   //     i,
            //   //     child,
            //   //     childProgress,
            //   //     progressObj
            //   //   );
            //   // if (value.id == 700)
            //   //   console.log("child progressesobj", progressObj);
            //   // if(overflowing && OUTER_RING_OVERFLOW){
            //   //   overflowProgress.push(progressObj)
            //   // }
            //   // else {
            //   childrenProgress.push(progressObj);
            //   // }
            // }
          } else if (child == "∞") {
            let freshness = frequencyHelpers.getFreshness(value);
            childrenProgress.push({
              offset: childrenOffset - i * (slotFill + slotGap),
              dashArray: [slotFill * freshness, C],
              color: valueHelpers.getColor(value, context.colorScheme),
              percent: freshness,
              freshness,
              // isTracker: true,
              isInfinite: true,
              // updated_at: child.updated_at,
              // iterations: child.iterations,
            });
          }
        });
        if (
          !CAP_AT_CYCLE ||
          // cycle !== 0 && incompleteChildren.length + progressions.length <= cycle
          // cycle !== 0 && incompleteChildren.length + progressions.length != cycle+1
          true
        ) {
          childrenDashArray.pop();
          childrenDashArray.push(C);

          if (!!overflowDashArray.length) {
            overflowDashArray.pop();
            overflowDashArray.push(C);
          }
        }
        // }

        if (
          incompleteChildren.length == 1 &&
          cycle == 1 &&
          !revisionWeights?.length
        ) {
          // childrenDashArray = [C];
          // offset = 0;
          // childrenLinecap = "square";
          // childrenOffset = 0;
        }
      }
    }
    // sort children notches by their percent progress
    // although this does not match TimelineNode/children sorting
    let sortChildrenByPercent = true;
    // sortChildrenByPercent = false;
    if (cycle != 0 || sortChildrenByPercent) {
      childrenProgress = textHelpers
        .newestFirst(childrenProgress, "percent")
        .map((cp, i) => {
          return {
            ...cp,
            offset: childrenOffset - i * (slotFill + slotGap),
          };
        });
    } else {
      // sort by updated_at, to match TimelineNode/children sorting
      childrenProgress = textHelpers
        .oldestFirst(childrenProgress, "created_at")
        .map((cp, i) => {
          return {
            ...cp,
            offset: childrenOffset - i * (slotFill + slotGap),
          };
        });
      if (centralValue) console.log(childrenProgress);
    }

    // remove overflow notches after sorting
    if (CAP_AT_CYCLE) {
      if (cycle !== 0) {
        childrenProgress = childrenProgress.slice(0, cycle);
      }
    }

    let archiveDashArray = [];
    // let archiveOffset = 0
    if (!!value.archived_at && !completedAt) {
      // progressions.map((p) => {
      //   archiveOffset -= (slotFill + slotGap)
      // })
      archiveDashArray = [C + archiveOffset + offset * 1.5];
    }

    // let emptyColor = ENV.DARK ? this.context.colors.fill : '#aaa'
    // let emptyColor = this.props.emptyColor || colorHelpers.hexToRgbaString(this.context.colors.subtle, 0.5)

    let emptyColor = this.props.emptyColor || context.colors.empty;

    // let activeColor = colorHelpers.averageColor([color, value.color])
    let activeColor =
      color || valueHelpers.colorAsHex(value.color, context.colorScheme);
    let highlightColor = colorHelpers.modifyHex(activeColor, 1.5);

    let ripe = false;
    let ripeColor;
    // if(progressions.length >= steps && !completedAt){
    //   ripe = true
    //   ripeColor = activeColor
    //   activeColor = this.props.valueColor
    //   if(ripeColor == activeColor){
    //     activeColor = colorHelpers.modifyHex(activeColor, 1.4)
    //   }
    // }

    let createdTodayOffset = 0;
    let createdTodayDashArray = [C];
    if (revisionWeights.length) {
      createdTodayOffset = progressSquareOffset;
      createdTodayDashArray = [C - revisionDotsSpan - dotGapArc * 2];
    }

    let milestoneOffset = rootOffset;

    let pathWrapper = {
      ...StyleSheet.absoluteFillObject,
      bottom: progressBar ? -strokeWidth : 0,
      height: progressBar ? strokeWidth : sizeRatio,
      // height: progressBar ? sizeRatio/3 : sizeRatio,
      height: sizeRatio,
      width: sizeRatio,
      // overflow: 'visible',
      // borderWidth: 2, borderColor: 'red',
      transform: [
        // progressBar ? {} :
        { rotate: `${rotation}deg` },
      ],
    };

    let wrapperStyle = {
      // borderWidth: 1, borderColor: 'red',
      borderRadius: sizeRatio / 2,
    };
    if (!!this.props.wrapperStyle) {
      wrapperStyle = { ...wrapperStyle, ...this.props.wrapperStyle };
    }
    if (!!this.props.gutter) {
      wrapperStyle = {
        ...wrapperStyle,
        top: this.props.gutter,
        right: this.props.gutter,
        left: this.props.gutter,
        bottom: this.props.gutter,
      };
    }

    if (centralValue && !this.INSPECTED) {
      this.INSPECTED = true;
      console.log("CENTRAL VALUE INSPECTION", {
        value,
        progressions,
        incompleteChildren,
        steps,
        cycle,
      });
    }

    return {
      key: (this.state?.key || 0) + 1,
      // VALUES ATTR
      doneToday,
      completedAt,
      completedToday,
      createdToday: false,
      progressions,
      incompleteChildren,
      cycle,
      steps,
      showFreshnessRing:
        !completedAt &&
        (valueHelpers.isInfinite(value) || valueHelpers.isProject(value)),
      // SIZES
      strokeWidth,
      progressStrokeWidth,
      outterR,
      R,
      C,
      dotSize,
      dotGap,
      dotGapArc,
      slot,
      slotGap,
      slotFill,
      rootOffset,
      offset,
      // REVISION DOTS
      revisionDotsSpan,
      revisionWeights,
      rotation,
      revisionDashArray,
      revisionWeightsLength,
      revisionDotsArc,
      ringOffset,
      // PROGRESS
      dashArray,
      progressLinecap,
      dashCount,
      progressStartDash,
      progressEndDash,
      progressSquareOffset,
      progressEndOffset,
      progressDash,
      progressDashArray,
      todayDashArray,
      todayOffset,
      todayLinecap,
      archiveOffset,
      childrenOffset,
      childrenLinecap,
      childrenDashArray,
      childrenProgress,
      overflowDashArray,
      overflowProgress,
      // STYLES
      pathWrapper,
      wrapperStyle,
      emptyColor,
      activeColor,
      highlightColor,
      ripe,
      ripeColor,
      createdTodayOffset,
      createdTodayDashArray,
      milestoneOffset,
      colorScheme: context.colorScheme,
    };
  };

  async componentDidUpdate(prevProps) {
    if (this.props.editing) return;
    if (
      !textHelpers.compareObjects(this.props.value, prevProps.value) ||
      this.props.size != prevProps.size ||
      this.props.emptyColor != prevProps.emptyColor ||
      this.props.refreshKey != prevProps.refreshKey ||
      this.context.colorScheme != this.state.colorScheme
    ) {
      // console.log("UPDATING PROGRESS RING", this.props.value.id);
      let state = this.initialState();
      this.setState({ ...state });
    }

    if (
      !this.state.completed &&
      !!valueHelpers.getCompletedAt(this.props.value)
    ) {
      this.runCompletionAnimation();
    } else if (
      this.state.completed &&
      !valueHelpers.getCompletedAt(this.props.value)
    ) {
      this.setState({ completed: false });
    }

    // if (
    //   this.props.value.timeline?.length != prevProps.value.timeline?.length &&
    //   this.props.value.id == 235
    // ) {
    //   // console.log('timeline length changed', prevProps.value.timeline?.length, this.props.value.timeline?.length)
    // }

    // if (this.props.value.timeline?.length != prevProps.value.timeline?.length) {
    //   if (
    //     this.props.value.timeline?.length > prevProps.value.timeline?.length
    //   ) {
    //     if (!valueHelpers.getCompletedAt(this.props.value)) {
    //       let waitForCompletionAnim = false;
    //       this.runProgressAnimation(waitForCompletionAnim);
    //     }
    //   }
    // }
  }

  distanceAsArc = (distance, r, c) => {
    if (this.props.progressBar) {
      // return distance
    }
    let x = distance / r;
    let angle = (Math.asin(x) * 180) / Math.PI;
    if (!angle) angle = 1;
    let arc = c * (angle / 360);
    return arc;
  };

  renderProgressRing = (selected, color) => {
    let {
      Elem,
      completionAnimRunning,
      rotAnim,
      scaleAnim,
      progressAnimRunning,
      progressAnim,
      centralValue,
      // VALUES ATTR
      doneToday,
      completedAt,
      completedToday,
      createdToday,
      progressions,
      incompleteChildren,
      cycle,
      steps,
      showFreshnessRing,
      // SIZES
      strokeWidth,
      progressStrokeWidth,
      outterR,
      R,
      C,
      dotSize,
      dotGap,
      dotGapArc,
      slot,
      slotGap,
      slotFill,
      rootOffset,
      offset,
      // REVISION DOTS
      revisionDotsSpan,
      revisionWeights,
      rotation,
      revisionDashArray,
      revisionWeightsLength,
      revisionDotsArc,
      ringOffset,
      // PROGRESS
      dashArray,
      progressLinecap,
      dashCount,
      progressStartDash,
      progressEndDash,
      progressSquareOffset,
      progressEndOffset,
      progressDash,
      progressDashArray,
      todayDashArray,
      todayOffset,
      todayLinecap,
      archiveOffset,
      childrenOffset,
      childrenLinecap,
      childrenDashArray,
      childrenProgress,
      overflowDashArray,
      overflowProgress,
      // STYLES
      pathWrapper,
      wrapperStyle,
      emptyColor,
      activeColor,
      highlightColor,
      ripe,
      ripeColor,
      createdTodayOffset,
      createdTodayDashArray,
      milestoneOffset,
    } = this.state;
    let { value, size, progressBar } = this.props;
    let { sizeRatio, appliedScreenRatio, gutter } = this.getSizes();

    if (completionAnimRunning) completedAt = null;

    let SVG = null;

    const rot = rotAnim.interpolate({
      inputRange: [0, 100],
      outputRange: ["0deg", `${360 * 10}deg`],
    });

    SVG = (
      <Animated.View
        // key={this.state.key}
        style={{
          ...StyleSheet.absoluteFillObject,
          transform: [
            { scale: scaleAnim },
            // progressBar ? {} :
            { rotate: rot },
          ],
        }}
      >
        <View
          style={[
            pathWrapper,
            progressBar ? styles.progressBarSvgWrapper : styles.svgWrapper,
            wrapperStyle,
          ]}
        >
          {/* empty ring if created today */}
          {/*!selected && !dashCount && createdToday && (
            <View style={pathWrapper}>
              <Svg tabIndex={-1} height="100%" width="100%" viewBox={`0 0 ${sizeRatio} ${sizeRatio}`}>
                <Elem tabIndex={-1} cx={outterR} cy={outterR} r={R} stroke={emptyColor} strokeWidth={strokeWidth} fill="transparent" strokeDasharray={createdTodayDashArray} strokeDashoffset={createdTodayOffset} strokeLinecap="round" />
              </Svg>
            </View>
          )*/}

          {/* empty notches */}
          {(selected || createdToday) && (
            <View style={pathWrapper}>
              <Svg
                tabIndex={-1}
                height="100%"
                width="100%"
                viewBox={`0 0 ${sizeRatio} ${sizeRatio}`}
              >
                <Elem
                  tabIndex={-1}
                  cx={outterR}
                  cy={outterR}
                  r={R}
                  stroke={emptyColor}
                  strokeWidth={strokeWidth}
                  fill="transparent"
                  strokeDasharray={dashArray}
                  strokeDashoffset={offset}
                  strokeLinecap="round"
                  d={`M${R * 2 + strokeWidth * 2},0 l0,${R * 2}`}
                />
              </Svg>
            </View>
          )}
          {/* ripe ring */}
          {ripe && (
            <View style={pathWrapper}>
              <Svg
                tabIndex={-1}
                height="100%"
                width="100%"
                viewBox={`0 0 ${sizeRatio} ${sizeRatio}`}
              >
                <Elem
                  tabIndex={-1}
                  cx={outterR}
                  cy={outterR}
                  r={R}
                  stroke={ripeColor}
                  strokeWidth={strokeWidth * 1.5}
                  fill="transparent"
                  strokeDasharray={[C]}
                  strokeLinecap="square"
                  d={`M${R * 2 + strokeWidth * 2},0 l0,${R * 2}`}
                />
              </Svg>
            </View>
          )}

          {this.renderMilestoneDots()}

          {/* cycle outline */}
          {SHOW_CYCLE_OUTLINE &&
            !completedAt &&
            !valueHelpers.isInfinite(value) &&
            steps > cycle && (
              <View style={pathWrapper}>
                <Svg
                  tabIndex={-1}
                  height="100%"
                  width="100%"
                  viewBox={`0 0 ${sizeRatio} ${sizeRatio}`}
                >
                  <Elem
                    tabIndex={-1}
                    cx={outterR}
                    cy={outterR}
                    r={R}
                    stroke={activeColor}
                    strokeWidth={progressStrokeWidth * 1.5}
                    fill="transparent"
                    strokeDasharray={[slot * cycle + progressSquareOffset, C]}
                    strokeDashoffset={progressSquareOffset}
                    strokeLinecap={progressLinecap}
                    tabIndex={-1}
                    d={`M${R * 2 + strokeWidth * 2},0 l0,${R * 2}`}
                  />
                  <Elem
                    tabIndex={-1}
                    cx={outterR}
                    cy={outterR}
                    r={R}
                    stroke={emptyColor}
                    strokeWidth={progressStrokeWidth * 1.35}
                    fill="transparent"
                    strokeDasharray={[slot * cycle + progressSquareOffset, C]}
                    strokeDashoffset={progressSquareOffset}
                    strokeLinecap={progressLinecap}
                    tabIndex={-1}
                    d={`M${R * 2 + strokeWidth * 2},0 l0,${R * 2}`}
                  />
                  {/*
              <SvgText x={R} y={R} fill={this.context.colors.foreground} textAnchor="left" 
                // rotation={ENV.WEB && "-90"}
                // transform={`rotate(-90)`}
                style={{fontSize: this.context.sizes.base*2, fontWeight: 100}} pointerEvents='none'
              >
                {steps}/{cycle}-{progressSquareOffset}
              </SvgText>
              */}
                </Svg>
              </View>
            )}

          {this.renderNotches()}

          {/* archived closure */}
          {this.renderArchiveClosure()}
        </View>
      </Animated.View>
    );
    return SVG;
  };

  renderMilestoneDots = () => {
    let {
      Elem,
      revisionWeights,
      milestoneOffset,
      dotGapArc,
      pathWrapper,
      outterR,
      R,
      C,
      activeColor,
      strokeWidth,
      milestoneLinecap,
      emptyColor,
    } = this.state;
    let { sizeRatio, appliedScreenRatio, gutter } = this.getSizes();
    {
      /* milestone dots */
    }
    {
      /*revisionDashArray.length > 0 && (
      <View style={pathWrapper}>
        <Svg tabIndex={-1} height="100%" width="100%" viewBox={`0 0 ${sizeRatio} ${sizeRatio}`}>
          <Elem tabIndex={-1} cx={outterR} cy={outterR} r={R} stroke={activeColor} strokeWidth={strokeWidth} fill="transparent" strokeDasharray={revisionDashArray} strokeDashoffset={rootOffset} strokeLinecap="round"/>
        </Svg>
      </View>
    )*/
    }
    return revisionWeights.map((r, i) => {
      let milestoneLinecap = r == 1 ? "round" : "square";
      if (i > 0) milestoneOffset -= dotGapArc;
      if (r == 1) {
        return (
          <View style={pathWrapper} key={i}>
            <Svg
              tabIndex={-1}
              height="100%"
              width="100%"
              viewBox={`0 0 ${sizeRatio} ${sizeRatio}`}
            >
              <Elem
                tabIndex={-1}
                cx={outterR}
                cy={outterR}
                r={R}
                stroke={activeColor}
                strokeWidth={strokeWidth}
                fill="transparent"
                strokeDasharray={[0, C]}
                strokeDashoffset={milestoneOffset}
                strokeLinecap={milestoneLinecap}
                d={`M${R * 2 + strokeWidth * 2},0 l0,${R * 2}`}
              />
            </Svg>
          </View>
        );
      } else if (["#"].includes(r)) {
        if (!ENV.WEB) return null;
        return (
          <View style={pathWrapper} key={i}>
            <Svg
              tabIndex={-1}
              height="100%"
              width="100%"
              viewBox={`0 0 ${sizeRatio} ${sizeRatio}`}
              rotation={ENV.WEB && "-87"}
            >
              <SvgText
                x={R}
                y={R * 2 + strokeWidth * 1.5}
                fill={activeColor}
                textAnchor="center"
                style={{
                  fontSize: strokeWidth * 3,
                  fontWeight: 900,
                  borderWidth: 1,
                }}
                pointerEvents="none"
              >
                {r}
              </SvgText>
            </Svg>
          </View>
        );
      } else if (["∞"].includes(r)) {
        if (!ENV.WEB) return null;
        return (
          <View style={pathWrapper} key={i}>
            <Svg
              tabIndex={-1}
              height="100%"
              width="100%"
              viewBox={`0 0 ${sizeRatio} ${sizeRatio}`}
              rotation={ENV.WEB && "-85"}
            >
              <SvgText
                x={R}
                y={R * 2 + strokeWidth * 1.6}
                fill={activeColor}
                textAnchor="center"
                style={{
                  fontSize: strokeWidth * 3,
                  fontWeight: 900,
                  borderWidth: 1,
                }}
                pointerEvents="none"
              >
                {r}
              </SvgText>
            </Svg>
          </View>
        );
      } else if (r == "+") {
        {
          /*return (
          <View style={pathWrapper} key={i}>
            <Svg tabIndex={-1} height="100%" width="100%" viewBox={`0 0 ${sizeRatio} ${sizeRatio}`}>
              <Elem tabIndex={-1} cx={outterR} cy={outterR} r={R} 
                stroke={activeColor} 
                strokeWidth={strokeWidth*1.3} 
                fill="transparent" 
                strokeDasharray={[0,C]} 
                strokeDashoffset={milestoneOffset} 
                strokeLinecap={'square'}
                strokeLinecap={'round'}
                d={`M${(R*2)+(strokeWidth*2)},0 l0,${R*2}`}
              />
              <Elem tabIndex={-1} cx={outterR} cy={outterR} r={R} 
                stroke={emptyColor} 
                strokeWidth={strokeWidth*0.9} 
                fill="transparent" 
                strokeDasharray={[0,C]} 
                strokeDashoffset={milestoneOffset} 
                strokeLinecap={'square'}
                strokeLinecap={'round'}
                d={`M${(R*2)+(strokeWidth*2)},0 l0,${R*2}`}
              />
            </Svg>
          </View>
        )*/
        }
        if (!ENV.WEB) return null;
        return (
          <View style={pathWrapper} key={i}>
            <Svg
              tabIndex={-1}
              height="100%"
              width="100%"
              viewBox={`0 0 ${sizeRatio} ${sizeRatio}`}
              rotation={ENV.WEB && "-90"}
            >
              <SvgText
                x={R}
                y={R * 2 + strokeWidth * 1.0}
                fill={activeColor}
                textAnchor="center"
                // style={{ fontSize: strokeWidth * 3, fontWeight: 900 }}
                style={{ fontSize: strokeWidth * 2, fontWeight: 400 }}
                pointerEvents="none"
                // onClick={() => alert('expand')}
              >
                +
              </SvgText>
            </Svg>
          </View>
        );
      } else {
        return (
          <View style={pathWrapper} key={i}>
            <Svg
              tabIndex={-1}
              height="100%"
              width="100%"
              viewBox={`0 0 ${sizeRatio} ${sizeRatio}`}
            >
              <Elem
                tabIndex={-1}
                cx={outterR}
                cy={outterR}
                r={R}
                stroke={activeColor}
                strokeWidth={strokeWidth * 1.3}
                fill="transparent"
                strokeDasharray={[0, C]}
                strokeDashoffset={milestoneOffset}
                strokeLinecap={"round"}
                d={`M${R * 2 + strokeWidth * 2},0 l0,${R * 2}`}
              />
              <Elem
                tabIndex={-1}
                cx={outterR}
                cy={outterR}
                r={R}
                stroke={emptyColor}
                strokeWidth={strokeWidth * 0.9}
                fill="transparent"
                strokeDasharray={[0, C]}
                strokeDashoffset={milestoneOffset}
                strokeLinecap={"round"}
                d={`M${R * 2 + strokeWidth * 2},0 l0,${R * 2}`}
              />
              {r == 10 && (
                <Elem
                  tabIndex={-1}
                  cx={outterR}
                  cy={outterR}
                  r={R}
                  stroke={activeColor}
                  strokeWidth={strokeWidth * 0.5}
                  fill="transparent"
                  strokeDasharray={[0, C]}
                  strokeDashoffset={milestoneOffset}
                  strokeLinecap={"round"}
                  d={`M${R * 2 + strokeWidth * 2},0 l0,${R * 2}`}
                />
              )}
            </Svg>
          </View>
        );
      }
    });
  };

  renderNotches = () => {
    let { value, progressBar, coloredNotches } = this.props;
    let {
      Elem,
      offset,
      pathWrapper,
      outterR,
      R,
      activeColor,
      strokeWidth,
      slotFill,
      C,
      showFreshnessRing,
      completedAt,
      progressDashArray,
      progressions,
      slotGap,
      childProgress,
      childrenProgress,
      progressLinecap,
      emptyColor,
      progressStrokeWidth,
      progressSquareOffset,
      todayDashArray,
      progressAnimRunning,
      progressAnim,
      todayOffset,
      todayLinecap,
      cycle,
      centralValue,
    } = this.state;
    let { sizeRatio, appliedScreenRatio, gutter } = this.getSizes();

    let scaleFactor = 1;
    let rotFactor = `0deg`;
    if (progressAnimRunning) {
      scaleFactor = progressAnim.interpolate({
        inputRange: [0, 1],
        outputRange: [0.8, 1],
      });
    }

    return (
      <View>
        {/* non-colored progress notches or completed ring */}
        {(!coloredNotches || !!completedAt) && progressDashArray.length > 0 && (
          <View>
            <View style={pathWrapper}>
              <Svg
                tabIndex={-1}
                height="100%"
                width="100%"
                viewBox={`0 0 ${sizeRatio} ${sizeRatio}`}
              >
                <Elem
                  tabIndex={-1}
                  cx={outterR}
                  cy={outterR}
                  r={R}
                  stroke={activeColor}
                  // stroke={valueHelpers.getColor(progressions[progressions.length-1].value)}
                  strokeWidth={progressStrokeWidth}
                  fill="transparent"
                  strokeDasharray={progressDashArray}
                  strokeDashoffset={progressSquareOffset}
                  strokeLinecap={progressLinecap}
                  tabIndex={-1}
                  d={`M${R * 2 + strokeWidth * 2},0 l0,${R * 2}`}
                />
              </Svg>
            </View>
          </View>
        )}

        {/* colored progress notches */}
        {!completedAt &&
          coloredNotches &&
          progressions.map((notch, i) => {
            // if (!!notch.color) console.log(value.text, notch.color);
            let rawColor = notch.color || notch.value?.color || notch.color;
            let notchColor = valueHelpers.colorAsHex(
              rawColor,
              this.context.colorScheme
            );
            let color = notchColor || activeColor;
            let notchOffset = -(slotFill + slotGap) * i;
            let notchArray = [slotFill, C];

            let wasToday =
              timeHelpers.wasToday(notch?.timestamp, this.props.date) &&
              !completedAt;
            wasToday = false;

            let stroke = strokeWidth;
            if (wasToday) stroke += strokeWidth / 2;
            else if (!!value.frequency) {
              // thin each notch for it's staleness
              let checkAgainst = progressions[i + 1]?.timestamp || null;
              let notchStaleness = frequencyHelpers.getStaleness(
                value,
                notch.timestamp,
                checkAgainst
              );
              // stroke = stroke - (stroke / 2) * notchStaleness;
            }
            // if (!!notch.iterations) stroke += (strokeWidth / 2) * notch.iterations;
            stroke = Math.min(strokeWidth * 2, stroke);

            return (
              <View key={i} style={[pathWrapper]}>
                <Svg
                  tabIndex={-1}
                  height="100%"
                  width="100%"
                  viewBox={`0 0 ${sizeRatio} ${sizeRatio}`}
                >
                  <Elem
                    tabIndex={-1}
                    cx={outterR}
                    cy={outterR}
                    r={R}
                    strokeWidth={stroke}
                    strokeDasharray={notchArray}
                    strokeDashoffset={offset + notchOffset}
                    stroke={color}
                    fill="transparent"
                    strokeLinecap={
                      i == progressions.length - 1 ? progressLinecap : "round"
                    }
                    d={`M${R * 2 + strokeWidth * 2},0 l0,${R * 2}`}
                  />
                </Svg>
              </View>
            );
          })}

        {/* today notches */}
        {!coloredNotches && todayDashArray.length > 0 && (
          <Animated.View
            style={[
              pathWrapper,
              {
                transform: [...pathWrapper.transform, { scale: scaleFactor }],
              },
            ]}
          >
            <Svg
              tabIndex={-1}
              height="100%"
              width="100%"
              viewBox={`0 0 ${sizeRatio} ${sizeRatio}`}
            >
              <Elem
                tabIndex={-1}
                cx={outterR}
                cy={outterR}
                r={R}
                // stroke={highlightColor} strokeWidth={strokeWidth*1.2} // color change
                stroke={activeColor}
                strokeWidth={strokeWidth * 1.5} // stroke change
                strokeWidth={strokeWidth} // stroke change
                fill="transparent"
                strokeDasharray={todayDashArray}
                strokeDashoffset={offset + todayOffset}
                strokeLinecap={todayLinecap}
                // stroke={'red'}
                d={`M${R * 2 + strokeWidth * 2},0 l0,${R * 2}`}
              />
            </Svg>
          </Animated.View>
        )}

        {/* open children notches */}
        {!INVERT_NOTCH_COLORS && // parent color for notch border, child for notch fill
          !completedAt &&
          childrenDashArray.length > 0 &&
          (!CAP_AT_CYCLE || progressions.length < cycle || cycle == 0) && (
            <View style={pathWrapper}>
              <Svg
                tabIndex={-1}
                height="100%"
                width="100%"
                viewBox={`0 0 ${sizeRatio} ${sizeRatio}`}
              >
                {/*notch outline*/}
                <Elem
                  tabIndex={-1}
                  cx={outterR}
                  cy={outterR}
                  r={R}
                  stroke={activeColor}
                  strokeWidth={strokeWidth * 1.1}
                  fill="transparent"
                  strokeDasharray={childrenDashArray}
                  strokeDashoffset={offset + childrenOffset}
                  strokeLinecap={childrenLinecap}
                  d={`M${R * 2 + strokeWidth * 2},0 l0,${R * 2}`}
                />
                {/*notch emptiness*/}
                <Elem
                  tabIndex={-1}
                  cx={outterR}
                  cy={outterR}
                  r={R}
                  stroke={emptyColor}
                  strokeWidth={strokeWidth * 0.95}
                  fill="transparent"
                  strokeDasharray={childrenDashArray}
                  strokeDashoffset={offset + childrenOffset}
                  strokeLinecap={childrenLinecap}
                  d={`M${R * 2 + strokeWidth * 2},0 l0,${R * 2}`}
                />
              </Svg>
            </View>
          )}

        {/*notch fill*/}
        {/* and border if INVERT_NOTCH_COLORS */}
        {!completedAt &&
          childrenProgress.map((childProgress, i) => {
            let bonus = 0;
            if (CAP_AT_CYCLE) {
              if (i + progressions.length + 1 > cycle && cycle != 0) {
                if (OUTER_RING_OVERFLOW) {
                  bonus = -(strokeWidth * 1.1);
                } else {
                  return null;
                }
              }
            }

            let stroke = strokeWidth;
            if (!!childProgress.iterations) {
              // stroke += (strokeWidth / 2) * childProgress.iterations;
            }
            stroke = Math.min(strokeWidth * 2, stroke);

            // if (centralValue) console.log(i, childProgress, bonus, stroke);
            return (
              <View key={i} style={pathWrapper}>
                <Svg
                  tabIndex={-1}
                  height="100%"
                  width="100%"
                  viewBox={`0 0 ${sizeRatio} ${sizeRatio}`}
                >
                  {/* notch border */}
                  {INVERT_NOTCH_COLORS && (
                    <Elem
                      tabIndex={-1}
                      cx={outterR}
                      cy={outterR}
                      r={R + bonus}
                      fill="transparent"
                      strokeLinecap="round"
                      strokeDashoffset={offset + childProgress.offset}
                      // stroke={activeColor}
                      stroke={
                        childProgress.isInfinite
                          ? emptyColor
                          : childProgress.color
                      }
                      strokeWidth={
                        childProgress.isInfinite ? stroke : stroke * 1.1
                      }
                      strokeDasharray={[slotFill, C]}
                      style={{ opacity: 0.7 }}
                    />
                  )}
                  {/* empty notch negative space */}
                  {INVERT_NOTCH_COLORS && (
                    <Elem
                      tabIndex={-1}
                      cx={outterR}
                      cy={outterR}
                      r={R + bonus}
                      fill="transparent"
                      strokeLinecap="round"
                      strokeDashoffset={offset + childProgress.offset}
                      stroke={
                        childProgress.isInfinite
                          ? childProgress.color
                          : emptyColor
                      }
                      style={childProgress.isInfinite && { opacity: 0.25 }}
                      strokeWidth={
                        childProgress.isInfinite ? stroke : stroke * 0.8
                      }
                      strokeDasharray={[slotFill, C]}
                    />
                  )}
                  {/* notch fill */}
                  {!!childProgress.percent && (
                    <Elem
                      tabIndex={-1}
                      cx={outterR}
                      cy={outterR}
                      r={R + bonus}
                      fill="transparent"
                      strokeLinecap={
                        childProgress.isInfinite ? "round" : "square"
                      }
                      strokeDashoffset={offset + childProgress.offset}
                      stroke={childProgress.color}
                      style={!childProgress.isInfinite && { opacity: 0.5 }}
                      strokeWidth={
                        childProgress.isInfinite ? stroke : stroke * 0.8
                      }
                      strokeDasharray={childProgress.dashArray}
                      d={`M${R * 2 + strokeWidth * 2},0 l0,${R * 2}`}
                    />
                  )}
                </Svg>
              </View>
            );
          })}
      </View>
    );
  };

  renderFreshnessRing = () => {
    let { value, progressBar } = this.props;
    let {
      Elem,
      offset,
      pathWrapper,
      outterR,
      R,
      activeColor,
      strokeWidth,
      slotFill,
      C,
      showFreshnessRing,
      revisionDotsSpan,
    } = this.state;
    let { sizeRatio, appliedScreenRatio, gutter } = this.getSizes();
    if (showFreshnessRing) {
      let freshness = frequencyHelpers.getFreshness(value);
      // console.log(value.text, freshness);
      return (
        <View style={pathWrapper} key={"freshness-ring"}>
          <Svg
            tabIndex={-1}
            height="100%"
            width="100%"
            viewBox={`0 0 ${sizeRatio} ${sizeRatio}`}
          >
            <Elem // infinite tracker background track
              tabIndex={-1}
              cx={outterR}
              cy={outterR}
              r={R}
              fill="transparent"
              strokeLinecap="round"
              strokeDashoffset={offset}
              stroke={activeColor}
              strokeWidth={strokeWidth}
              strokeDasharray={[C - revisionDotsSpan]}
              style={{ opacity: 0.25 }}
            />

            <Elem // infinite tracker freshness
              tabIndex={-1}
              cx={outterR}
              cy={outterR}
              r={R}
              fill="transparent"
              strokeLinecap="round"
              strokeDashoffset={offset}
              stroke={activeColor}
              strokeWidth={strokeWidth}
              strokeDasharray={[(C - revisionDotsSpan) * freshness, C]}
              d={`M${R * 2 + strokeWidth * 2},0 l0,${R * 2}`}
            />
          </Svg>
        </View>
      );
    }
    return null;
  };

  renderArchiveClosure = () => {
    let {
      archiveDashArray,
      pathWrapper,
      outterR,
      R,
      strokeWidth,
      offset,
      archiveOffset,
    } = this.state;
    let { sizeRatio, appliedScreenRatio, gutter } = this.getSizes();
    if (!!archiveDashArray?.length) {
      return (
        <View style={pathWrapper}>
          <Svg
            tabIndex={-1}
            height="100%"
            width="100%"
            viewBox={`0 0 ${sizeRatio} ${sizeRatio}`}
          >
            <Elem
              tabIndex={-1}
              cx={outterR}
              cy={outterR}
              r={R}
              stroke={this.context.colors.trim}
              strokeWidth={strokeWidth * 1.2}
              fill="transparent"
              strokeDasharray={archiveDashArray}
              strokeDashoffset={offset + archiveOffset}
              strokeLinecap={"round"}
              d={`M${R * 2 + strokeWidth * 2},0 l0,${R * 2}`}
            />
          </Svg>
        </View>
      );
    }
  };

  getSteps = (value, cycle, progressions, incompleteChildren = []) => {
    if (!cycle && cycle !== 0) cycle = 7;

    if (valueHelpers.isInfiniteTracker(value)) {
      return 1;
    }
    let steps = Math.max(progressions.length, cycle);
    if (cycle == 0) {
      steps = progressions.length + (incompleteChildren?.length || 0);
    }

    // if (cycle === 0 || !CAP_AT_CYCLE || !ENV.STACK_PROGRESS) {
    // flex step sizes to match number of children
    steps = progressions.length + (incompleteChildren?.length || 0);
    steps = Math.max(steps, cycle);
    // }

    if (isNaN(steps)) {
      console.log(steps, typeof steps, progressions.length, cycle);
      steps = 7;
    }

    return steps;
  };

  runCompletionAnimation = async () => {
    console.log("completed!");
    await this.setState({ completionAnimRunning: true, completed: true });

    setTimeout(() => {
      console.log("completionAnimRunning false");
      this.setState({ completionAnimRunning: false });
    }, 2000);

    console.log("run anim...");

    // Animated.timing(this.state.rotAnim, {
    //   toValue: 180,
    //   duration: 4000,
    //   // easing: Easing.in(Easing.quad),
    // }).start()
    // return

    Animated.sequence([
      Animated.parallel([
        Animated.timing(this.state.rotAnim, {
          toValue: 100,
          duration: 2000,
          easing: Easing.in(Easing.quad),
          useNativeDriver: !ENV.WEB,
        }),
        Animated.timing(this.state.scaleAnim, {
          delay: 2000,
          toValue: 1.05,
          duration: 500,
          easing: Easing.in(Easing.quad),
          useNativeDriver: !ENV.WEB,
        }),
      ]),
      // wind down
      Animated.parallel([
        Animated.timing(this.state.rotAnim, {
          toValue: 0,
          duration: 500,
          easing: Easing.out(Easing.quad),
          useNativeDriver: !ENV.WEB,
        }),
        Animated.timing(this.state.scaleAnim, {
          delay: 0,
          toValue: 1,
          duration: 250,
          easing: Easing.out(Easing.quad),
          useNativeDriver: !ENV.WEB,
        }),
      ]),
    ]).start();
  };

  runProgressAnimation = async (delay = false) => {
    console.log("progressing!");
    if (this.state.progressAnimRunning) return;
    await this.setState({ progressAnimRunning: true });

    this.state.progressAnim.setValue(0);

    // Animated.spring(this.state.progressAnim, {
    //   delay: 3000,
    //   toValue: 1,
    //   // friction: 5,
    //   useNativeDriver: false,
    // }).start(() => {
    Animated.timing(this.state.progressAnim, {
      delay: delay ? 3000 : 0,
      toValue: 1,
      duration: 500,
      easing: Easing.bounce,
      useNativeDriver: !ENV.WEB,
    }).start(() => {
      this.setState({ progressAnimRunning: false });
    });
  };
}

const styles = StyleSheet.create({
  svgWrapper: {
    transform: [
      {
        rotate: "90deg",
      },
    ],
  },
  progressBarSvgWrapper: {
    // bottom: -5,
    top: "auto",
    transform: [
      {
        // rotate: '270deg',
        rotate: "90deg",
      },
    ],
  },
});
